export default __webpack_public_path__ + "static/media/error-pago.33b5610f.svg";